var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentMedal = function SvgDocumentMedal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 175,
    viewBox: "0 0 227 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 43C58 36.3726 63.3726 31 70 31H138C144.627 31 150 36.3726 150 43V151H70C63.3726 151 58 145.627 58 139V43Z",
    fill: "url(#paint0_linear_264_50860)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 92H156C160.418 92 164 95.5817 164 100V143C164 147.418 160.418 151 156 151H150V92Z",
    fill: "url(#paint1_linear_264_50860)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 50,
    width: 60,
    height: 5,
    rx: 2.5,
    fill: "#BBDEFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 62,
    width: 39,
    height: 5,
    rx: 2.5,
    fill: "#BBDEFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 74,
    width: 70,
    height: 5,
    rx: 2.5,
    fill: "#BBDEFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 86,
    width: 39,
    height: 5,
    rx: 2.5,
    fill: "#BBDEFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 107,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#BBDEFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 117,
    width: 30,
    height: 5,
    rx: 2.5,
    fill: "#BBDEFB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 114,
    r: 10,
    fill: "#BBDEFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.401 119.945C122.582 119.423 123.151 119.147 123.673 119.327L128.542 121.014C129.064 121.195 129.341 121.765 129.16 122.287L125.713 132.236C125.401 133.135 124.128 133.132 123.821 132.23L123.298 130.692C123.088 130.074 122.353 129.82 121.806 130.175L120.443 131.06C119.645 131.578 118.642 130.793 118.954 129.894L122.401 119.945Z",
    fill: "#BBDEFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.767 122.905C127.535 122.404 127.754 121.809 128.256 121.578L132.935 119.419C133.436 119.188 134.03 119.406 134.262 119.908L138.673 129.468C139.072 130.333 138.152 131.213 137.306 130.776L135.862 130.029C135.283 129.73 134.577 130.056 134.429 130.691L134.06 132.274C133.844 133.201 132.577 133.33 132.178 132.466L127.767 122.905Z",
    fill: "#BBDEFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_50860",
    x1: 103.573,
    y1: 43.3741,
    x2: 107.835,
    y2: 159.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_50860",
    x1: 162.25,
    y1: 99.5,
    x2: 137.682,
    y2: 103.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentMedal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "document-medal.aa66d3c6dd4439e2c28151685b92f495.svg";